import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiscalizacionRoutingModule } from './fiscalizacion-routing.module';
import { ConveniosComponent } from '../componentes/convenios/convenios.component';
import { ComponentesModule } from "../componentes/componentes.module";
import { EjecucionFiscalComponent } from '../componentes/ejecucion-fiscal/ejecucion-fiscal.component';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule} from 'primeng/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {DropdownModule} from 'primeng/dropdown';
import {TableModule} from 'primeng/table';
import { DialogModule } from "primeng/dialog";
import { MenubarModule } from "primeng/menubar";
import { GestorConveniosComponent } from '../componentes/gestor-convenios/gestor-convenios.component';



@NgModule({
  declarations: [ConveniosComponent, GestorConveniosComponent, EjecucionFiscalComponent,],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    FiscalizacionRoutingModule,
    ComponentesModule,
    InputTextModule,
    ButtonModule,
    DropdownModule,
    TableModule,
    MenubarModule,
    DialogModule,
  ]
})
export class FiscalizacionModule { }
